export { usePageSharedData } from './usePageSharedData';

